import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie-lxc';
import {scaleLinear} from 'd3-scale';
import lottie from 'lottie-web';

const INITIAL_FRAME_NUMBER = 0;

export class LottieLXC extends Lottie {
  componentDidMount() {
    /* Code from Parent Class :: START*/
    const {options, eventListeners} = this.props;

    const {loop, autoplay, animationData, rendererSettings, segments} = options;

    this.options = {
      container: this.el,
      renderer: 'svg',
      loop: loop !== false,
      autoplay: autoplay !== false,
      segments: segments !== false,
      animationData,
      rendererSettings,
    };

    this.options = {...this.options, ...options};

    this.anim = lottie.loadAnimation(this.options);
    this.registerEvents(eventListeners);
    /* Code from Parent Class :: END*/

    /* To set Frame to initial Slider value */
    this.anim.goToAndStop(this.getCurrentFrame(), true);
  }

  componentDidUpdate(prevProps) {
    /* Code from Parent Class :: START*/
    if (this.props.isStopped) {
      this.stop();
    } else if (this.props.segments) {
      this.playSegments();
    } else {
      this.play();
    }

    this.pause();
    this.setSpeed();
    this.setDirection();
    /* Code from Parent Class :: END*/

    /* To Update Frame when slider value changes */
    this.anim.goToAndStop(this.getCurrentFrame(), true);
  }

  getLastFrameNumber = () => this.anim.totalFrames - 1;

  getCurrentFrame = () =>
    scaleLinear()
      .domain(this.props.limits)
      .range([INITIAL_FRAME_NUMBER, this.getLastFrameNumber()])(
      this.props.current
    );
}

LottieLXC.propTypes = {
  ...Lottie.propTypes,
  /**
   * Limit values from the Slider [ min, max ]
   */
  limits: PropTypes.arrayOf(PropTypes.number),
  /**
   * Current value for slider
   */
  current: PropTypes.number,
};

LottieLXC.defaultProps = {
  isStopped: false,
  isPaused: false,
  eventListeners: [],
};
